import moment from 'moment/moment';

export const FIRELANDS_RELEASE_DATES = {
  us: moment.utc('2024-11-07T22:00:00'),
  eu: moment.utc('2024-11-07T22:00:00'),
  tw: moment.utc('2024-11-07T22:00:00'),
  kr: moment.utc('2024-11-07T22:00:00'),
  cn: moment.utc('2024-11-07T22:00:00')
};

export const DRAGON_SOUL_RELEASE_DATES = {
  us: moment.utc('2025-02-20T23:00:00'),
  eu: moment.utc('2025-02-20T23:00:00'),
  tw: moment.utc('2025-02-20T23:00:00'),
  kr: moment.utc('2025-02-20T23:00:00'),
  cn: moment.utc('2025-02-20T23:00:00')
};

export const MISTS_OF_PANDARIA_RAID_RELEASE_DATES = {
  us: moment.utc('2025-07-31T22:00:00'),
  eu: moment.utc('2025-07-31T22:00:00'),
  tw: moment.utc('2025-07-31T22:00:00'),
  kr: moment.utc('2025-07-31T22:00:00'),
  cn: moment.utc('2025-07-31T22:00:00')
};

export const HEART_OF_FEAR_RELEASE_DATES = {
  us: moment.utc('2025-08-21T22:00:00'),
  eu: moment.utc('2025-08-21T22:00:00'),
  tw: moment.utc('2025-08-21T22:00:00'),
  kr: moment.utc('2025-08-21T22:00:00'),
  cn: moment.utc('2025-08-21T22:00:00')
};

export const TERRACE_ENDLESS_SPRING_RELEASE_DATES = {
  us: moment.utc('2025-09-04T22:00:00'),
  eu: moment.utc('2025-09-04T22:00:00'),
  tw: moment.utc('2025-09-04T22:00:00'),
  kr: moment.utc('2025-09-04T22:00:00'),
  cn: moment.utc('2025-09-04T22:00:00')
};

export const THRONE_OF_THUNDER_RELEASE_DATES = {
  us: moment.utc('2025-12-09T22:00:00'),
  eu: moment.utc('2025-12-09T22:00:00'),
  tw: moment.utc('2025-12-09T22:00:00'),
  kr: moment.utc('2025-12-09T22:00:00'),
  cn: moment.utc('2025-12-09T22:00:00')
};

export const SIEGE_OF_ORGRIMMAR_RELEASE_DATES = {
  us: moment.utc('2026-06-04T22:00:00'),
  eu: moment.utc('2026-06-04T22:00:00'),
  tw: moment.utc('2026-06-04T22:00:00'),
  kr: moment.utc('2026-06-04T22:00:00'),
  cn: moment.utc('2026-06-04T22:00:00')
};
